import React from 'react';
import { createPortal } from 'react-dom';
import SpinnerSvg from './img/spinner.svg';
/** Spinning modal */
export default () => {
    return createPortal(
        <div className="loader">
            <img src={SpinnerSvg} />
        </div>,
        document.getElementById('modal-root')
    );
}